import React from "react";
import { motion } from "framer-motion";
import { FaRocket, FaChartLine, FaUsers, FaCalendarAlt, FaEnvelope } from "react-icons/fa";

const WarehouseDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo or Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ 
              type: "spring", 
              stiffness: 260, 
              damping: 20,
              delay: 0.2
            }}
            className="mb-8"
          >
            <div className="w-24 h-24 rounded-full bg-blue-500/20 flex items-center justify-center mx-auto">
              <FaRocket className="text-blue-400 text-5xl" />
            </div>
          </motion.div>

          {/* Main Heading */}
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
          >
            KSA Dashboard
          </motion.h1>

          {/* Subheading */}
          <motion.p 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl text-blue-100 mb-12"
          >
            Our new dashboard is coming soon
          </motion.p>

          {/* Features Preview */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
          >
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="flex items-center mb-4">
                <div className="p-3 rounded-full bg-blue-500/20 mr-4">
                  <FaChartLine className="text-blue-400 text-xl" />
                </div>
                <h3 className="text-xl font-semibold">Performance Analytics</h3>
              </div>
              <p className="text-blue-100">Track player progress, team statistics, and performance metrics in real-time.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="flex items-center mb-4">
                <div className="p-3 rounded-full bg-blue-500/20 mr-4">
                  <FaUsers className="text-blue-400 text-xl" />
                </div>
                <h3 className="text-xl font-semibold">Player Management</h3>
              </div>
              <p className="text-blue-100">Comprehensive player profiles, attendance tracking, and development assessments.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="flex items-center mb-4">
                <div className="p-3 rounded-full bg-blue-500/20 mr-4">
                  <FaCalendarAlt className="text-blue-400 text-xl" />
                </div>
                <h3 className="text-xl font-semibold">Schedule & Events</h3>
              </div>
              <p className="text-blue-100">Organize training sessions, matches, tournaments, and special events.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="flex items-center mb-4">
                <div className="p-3 rounded-full bg-blue-500/20 mr-4">
                  <FaEnvelope className="text-blue-400 text-xl" />
                </div>
                <h3 className="text-xl font-semibold">Communication Hub</h3>
              </div>
              <p className="text-blue-100">Connect with players, coaches, and parents through our integrated messaging system.</p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default WarehouseDashboard; 